export const farseValue = (value) => {
    if(value.indexOf("var:") === 0){
        const varVlue = value.split(':')[1].split('|').join('--');
        return `var(--wp--${varVlue})`;
    }
    return value;
}